import { TagService } from 'src/services/tag/tag.service';
import { getTopLevelTag, getTopLevelTagByFullPath } from './getTopLevelTag';
import { isRoot } from './isRoot';
import { Tag } from 'src/services/tag/Tag';

export function getTagColor<T extends Tag>(tag: T, tags: T[]): string {
  if (isRoot(tag.fullPath) && tag.color) {
    return tag.color;
  } else {
    const topLevelTag = getTopLevelTag(tag, tags);
    if (topLevelTag && topLevelTag.color) {
      return topLevelTag.color;
    } else {
      return TagService.DEFAULT_COLOR;
    }
  }
}
